import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthModal } from "screens/successorPage/components";
import { Field, Formik, Form } from "formik";
import {
  Button,
  Input,
  PageHead,
  DashboardTopBar,
  PasswordStrengthChecker,
  PasswordValidation,
} from "shared";
import * as Yup from "yup";
import { useSetNewPasswordByToken } from "hooks/successors";
import { useNavigate } from "react-router";
import { ROUTE_ENUM } from "enums";
const SuccessorResetPasswordPage = () => {
  const navigate = useNavigate();
  const [showValidation, setShowValidation] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const formRef = useRef<any>(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const { mutate } = useSetNewPasswordByToken({
    onSuccess: () => {
      navigate(ROUTE_ENUM.SUCCESSOR);
    },
  });

  const validation = () =>
    Yup.object().shape({
      password: Yup.string()
        .required("Pole wymagane")
        .min(8, "Minimum 8 znaków"),
      confirmPassword: Yup.string()
        .required("Pole wymagane")
        .oneOf([Yup.ref("password")], "Hasła muszą być takie same"),
    });

  const initialValues = {
    password: "",
  };

  const onSubmit = async (values: typeof initialValues) => {
    const { password } = values;
    if (token) {
      await mutate({ token, password });
    }
  };

  return (
    <>
      <PageHead
        title="Sukcesja – bezpieczne przekazanie informacji | App Reliance Pro"
        description="Zachowaj ciągłość decyzji i dostęp do ważnych dokumentów. Dodaj sukcesorów i przechowuj pliki w zakładce Sukcesja."
      />
      <DashboardTopBar>
        <h1 className="dashboard__header successor-page__top-bar">Sukcesja</h1>
      </DashboardTopBar>
      <AuthModal
        heading={"Ustawianie nowego hasła"}
        paragraph={
          <>
            Poniżej można ustawić nowe hasło do zakładki „Sukcesja”. Nowe hasło
            będzie wymagane przy każdorazowym dostępie do tej sekcji aplikacji.
          </>
        }
      >
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => onSubmit(values)}
          validationSchema={validation()}
          innerRef={formRef}
        >
          {({ values }) => (
            <Form>
              <Field
                type="password"
                id="password"
                name="password"
                label={"Hasło"}
                as={Input}
                onFocus={() => setShowValidation(true)}
                onBlur={() => isPasswordValid && setShowValidation(false)}
              />
              <PasswordStrengthChecker
                password={values.password}
                isHidden={!showValidation}
              />
              <PasswordValidation
                show={showValidation}
                password={values.password}
                setIsValid={(value: boolean) => setIsPasswordValid(value)}
              />
              <Field
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                label={"Powtórz hasło"}
                as={Input}
              />
              <Button
                className="successor-auth-modal__button"
                label={"Potwierdź hasło"}
                styleType="primary"
                type="submit"
                onClick={() => null}
              />
            </Form>
          )}
        </Formik>
      </AuthModal>
    </>
  );
};

export default SuccessorResetPasswordPage;
